exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "search form{display:inline-block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/active/search/search.styl
 ** module id = 198
 ** module chunks = 0
 **/